import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassengersComponent } from './passengers.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CheckBoxModule } from '../checkbox/checkbox.module';
import { ModalModule } from '../modal/modal.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PassengerTicketComponent } from './passenger-ticket/passenger-ticket.component';
import { SpecialRequestModalComponent } from './special-request-modal/special-request-modal.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { TitleModule } from '../title/title.module';
import { AlertModule } from '../alert/alert.module';
import { InfantReasignationModalComponent } from './infant-reasignation-modal/infant-reasignation-modal.component';
import { InputSelectModule } from '../input-select/input-select.module';
import { MatTabsModule } from '@angular/material/tabs';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { FlightSpecialRequestsModule } from './flight-special-requests/flight-special-requests.module';

@NgModule({
  declarations: [
    PassengersComponent,
    PassengerTicketComponent,
    SpecialRequestModalComponent,
    InfantReasignationModalComponent
  ],
  imports: [
    CommonModule,
    TitleModule,
    SharedModule,
    CheckBoxModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    MatTabsModule,
    AlertModule,
    TooltipModule,
    InputSelectModule,
    PipesModule,
    FlightSpecialRequestsModule
  ],
  exports: [PassengersComponent]
})
export class PassengersModule { }
